var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-item slider-item--final" }, [
    _c("h2", { ref: "title", staticClass: "slider-item__title" }, [
      _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")
    ]),
    _vm._v(" "),
    _c("img", {
      attrs: {
        src: "/ressources/logged/img/illustrations/recap2024/shape-recap.svg",
        width: "277"
      }
    }),
    _vm._v(" "),
    _vm.hasButton
      ? _c(
          "div",
          { ref: "actionButton" },
          [
            _c("CompassButton", {
              attrs: {
                type: "secondary-contrast",
                label: _vm.$t.__("recap.slider.FinalSlide.button")
              },
              on: { click: _vm.handleClick }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }